import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { PatientsService } from "../patients.service";
import { Patient } from "../patients/patient";
import { LoginService } from "../login.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "app-patdetails",
    templateUrl: "./patdetails.component.html",
    styleUrls: ["./patdetails.component.scss"],
    standalone: false
})
export class PatdetailsComponent implements OnInit {
  @Input("pat") myPat: Patient;
  @Input("awl") awl: number;
  @Input("awlTime") awlTime: string;
  @Input("awlExam") awlExam: string;
  @Input("awlLMP") awlLMP: string;
  @Input("awlComment") awlComment: string;
  @Input("openWAWL") open_w_awl: boolean;
  @Output() closed = new EventEmitter<string>();
  @Output() showpay = new EventEmitter<null>();

  @Input() currentTab: string;
  @Output() updateExercise = new EventEmitter<boolean>();

  warning: string;

  minLMP: Date;
  maxLMP: Date;
  maxBD: Date;
  startBD: Date;
  invalidlmp = "";
  LMP;
  Birth;
  openAWL: boolean;
  prnerr: string = null;
  treatmenterr: string = null;
  PRNVerified = false;
  iderr: string = null;
  idchanged = false;
  hideSave = false;
  ecode: number;
  ecodes: any[];
  ecodeTxt: string[];
  copyTo: number;
  tryCopy = false;
  copyNote: string;

  examTypes = [
    "1st",
    "NT",
    "Early Anatomy",
    "2nd/3rd Trimester",
    "Late Anatomy",
    "Specialized",
    "Fetal Echo",
    "Weight Assessment",
    "Tech Exam",
    "Gynecology",
    "Follicles",
    "Consultation Visit",
  ];
  echoExamList = ["אקו לב"];
  allCardioExamsList = [
    "אקו",
    "אקו ילדים",
    "אקו לב",
    "אקו מכבי",
    "אקו לאומית",
    "אקו מאוחדת",
    "אקו לב במאמץ",
    "אקו במאמץ מכבי",
    "אקו במאמץ לאומית",
    "אקו במאמץ מאוחדת",
    "אקו במאמץ פרטי",
    "ארגומטריה",
    "ארגומטריה מכבי",
    "ארגומטריה לאומית",
    "ארגומטריה מאוחדת",
    "הולטר קצב לב",
    "בדיקת אקג",
    "קרוטיד US עורקי צוואר",
    "ייעוץ קרדיולוגי",
    "יעוץ רפואי מכבי",
    "יעוץ רפואי לאומית",
    "יעוץ רפואי מאוחדת",
    "יעוץ רפואי כללית מושלם",
  ];
  GA;

  selectedMaccabiIndex: string = '';
  selectedMaccabiIndex2: string = '';

  constructor(
    private patservice: PatientsService,
    public ls: LoginService,
    private translate: TranslateService
  ) {
    this.maxLMP = new Date();
    this.maxLMP.setMonth(this.maxLMP.getMonth() - 1);
    this.minLMP = new Date();
    this.minLMP.setMonth(this.minLMP.getMonth() - 10);
    this.maxBD = new Date();
    this.maxBD.setFullYear(this.maxBD.getFullYear() - 12);
  }

  ngOnInit() {
    this.LMP = this.myPat.LMP;
    if (this.awlLMP) {
      this.GA = this.lmpGA(this.awlLMP);
    }
    this.Birth = this.myPat.Birth;
    // if(this.myPat.Birth.split(" ").length > 0)
    if (this.myPat.Birth && this.myPat.Birth != "") {
      this.myPat.Birth = this.myPat.Birth.split(" ")[0];
      this.startBD = new Date();
      this.startBD.setFullYear(this.startBD.getFullYear() - 22);
    }
    this.clearSpace();
    this.PRNVerified = !this.ls.PRNcheck; //don't check prn if diabled
    if (this.open_w_awl) this.openAWL = true;
    if (this.myPat["PaymentCodes"] && this.ls.ExamCodes) {
      //for belinson
      this.ecodes = this.myPat["PaymentCodes"].split(",");
      this.ecodeTxt = [];
      for (let code of this.ecodes) {
        for (let ec of this.ls.ExamCodes) {
          if (code == ec[0]) this.ecodeTxt.push(ec[1]);
        }
      }
    }
    
    // Load Macabi exam data on init and also set up to load it later if maccabiExams loads async
    this.loadMaccabiExamData();
    
  }
  
  loadMaccabiExamData() {
    if(this.myPat.HMOExamCode && this.ls.maccabiExams){
      let index = -1;
      
      if(this.myPat.HMOExamName){
        const patientExamName = this.myPat.HMOExamName.trim();
        index = this.ls.maccabiExams.findIndex(e => e.code == this.myPat.HMOExamCode && e.exam_name.trim() == patientExamName);
      }
      
      if (index === -1) {
        const examByCode = this.ls.maccabiExams.find(e => e.code == this.myPat.HMOExamCode);
        if (examByCode) {
          this.myPat.HMOExamName = examByCode.exam_name;
          index = this.ls.maccabiExams.findIndex(e => e === examByCode);
        }
      }

      this.selectedMaccabiIndex = index >= 0 ? index.toString() : '';
    } else if (this.myPat.HMOExamCode) {
      // If maccabiExams aren't loaded yet, wait and try again
      setTimeout(() => this.loadMaccabiExamData(), 100);
    }
    
    // Load second Maccabi exam code for combined exams
    if(this.myPat.HMOExamCode2 && this.ls.maccabiExams){
      let index2 = -1;
      
      if(this.myPat.HMOExamName2){
        const patientExamName2 = this.myPat.HMOExamName2.trim();
        index2 = this.ls.maccabiExams.findIndex(e => e.code == this.myPat.HMOExamCode2 && e.exam_name.trim() == patientExamName2);
      }
      
      if (index2 === -1) {
        const examByCode2 = this.ls.maccabiExams.find(e => e.code == this.myPat.HMOExamCode2);
        if (examByCode2) {
          this.myPat.HMOExamName2 = examByCode2.exam_name;
          index2 = this.ls.maccabiExams.findIndex(e => e === examByCode2);
        }
      }

      this.selectedMaccabiIndex2 = index2 >= 0 ? index2.toString() : '';
    } else if (this.myPat.HMOExamCode2) {
      // If maccabiExams aren't loaded yet, wait and try again
      setTimeout(() => this.loadMaccabiExamData(), 100);
    }
  }

  savePatient(cb = null, noclose = false) {
    this.hideSave = true;
    if (!this.myPat.UID && this.ls.doctor) this.myPat.UID = this.ls.doctor;
    this.patservice.savePatient(this.myPat, this.myPat.PID).subscribe(
      (data) => {
        if (data.hasOwnProperty("error")) {
          this.hideSave = false;
          this.warning = data["error"];
          if (cb) cb(data["error"]);
        } else {
          if (this.currentTab === "Findings") {
            this.updateExercise.emit(true);
          }
          if (!noclose) this.closed.emit("1");
          if (cb) cb(false);
        }
      }, // success path
      (error) => {
        // error path(data)=>
        this.hideSave = false;
        this.warning = error.error.error;
        if (cb) cb(error);
      }
    );
  }

  dateChanged(itemName: string) {
    try {
      this.myPat[itemName] = this[itemName].format("YYYY-MM-DD");
    } catch {}
    //this.myPat['LMP'] = this[itemName].format("YYYY-MM-DD");
    //this.GA = this.lmpGA(this.awlLMP);
  }

  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor((dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24));
    if (Math.floor(days / 7) < 1 || Math.floor(days / 7) > 50) return "";
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  close(toclose: boolean) {
    this.closed.emit(toclose ? "1" : null);
  }

  getBMI() {
    if (!this.myPat.Height || !this.myPat.Weight) return "";
    return Math.round((10 * this.myPat.Weight) / Math.pow(this.myPat.Height / 100, 2)) / 10;
  }

  getBSA() {
    if (this.myPat.BSAus) return this.myPat.BSAus;
    if (!this.myPat.Height || !this.myPat.Weight) return "";
    return Math.round(100 * Math.sqrt((this.myPat.Height * this.myPat.Weight) / 3600)) / 100 + "m²";
  }

  clearSpace() {
    try {
      this.myPat.ID = this.myPat.ID.replace(/\s+/, "");
    } catch (e) {}
  }

  onHMOExamCodeChange($event) {
    const selectedValue = $event.target.value;
    this.selectedMaccabiIndex = selectedValue;
    
    if (!selectedValue || selectedValue === '' || !this.ls.maccabiExams) {
      this.myPat.HMOExamCode = null;
      this.myPat.HMOExamName = null;
      return;
    }
    const exam = this.ls.maccabiExams[parseInt(selectedValue)];
    if (exam) {
      this.myPat.HMOExamCode = exam.code;
      this.myPat.HMOExamName = exam.exam_name;
    }
  }

  onHMOExamCodeChange2($event) {
    const selectedValue = $event.target.value;
    this.selectedMaccabiIndex2 = selectedValue;
    
    if (!selectedValue || selectedValue === '' || !this.ls.maccabiExams) {
      this.myPat.HMOExamCode2 = null;
      this.myPat.HMOExamName2 = null;
      return;
    }
    const exam = this.ls.maccabiExams[parseInt(selectedValue)];
    if (exam) {
      this.myPat.HMOExamCode2 = exam.code;
      this.myPat.HMOExamName2 = exam.exam_name;
    }
  }

  saveAWL() {
    // הוסף את הקודים אם זה בדיקת פנאומולוגיה ויש maccabiExams וה-HMO הוא מכבי
    let hmoExamCode = this.myPat.HMOExamCode;
    let hmoExamName = this.myPat.HMOExamName;
    
    if (this.myPat.HMO === 'Macabi' && this.ls.maccabiExams &&
        (this.ls.hasPremission("Pneumology") || this.ls.hasPremission("Methacholine"))) {
      if (this.awlExam) {
        const codes = this.getExamCodes(this.awlExam);
        if (codes.length > 0) {
          hmoExamCode = codes.join(',');
          hmoExamName = this.awlExam;
        }
      }
    }
    
    if (this.idchanged) {
      this.savePatient((err) => {
        if (!err)
          this.patservice
            .saveAWL(
              this.awl,
              this.awlTime,
              this.awlLMP,
              this.awlExam,
              this.awlComment,
              this.myPat.PID,
              this.myPat.PRN,
              this.myPat.Code,
              null,
              this.ls.isAdmin || this.ls.userType == "secretary"
                ? this.myPat.UID
                  ? this.myPat.UID
                  : this.ls.doctor
                : null,
              hmoExamCode,
              hmoExamName,
              this.myPat.PRN2,
              this.myPat.Code2,
              this.myPat.HMOExamCode2,
              this.myPat.HMOExamName2,
              this.clalitReferral()
            )
            .subscribe(
              (data) => {
                this.closed.emit("awl");
              },
              (error) => {
                console.log(error);
              }
            );
      }, true);
    } //only save awl
    else
      this.patservice
        .saveAWL(
          this.awl,
          this.awlTime,
          this.awlLMP,
          this.awlExam,
          this.awlComment,
          this.myPat.PID,
          this.myPat.PRN,
          this.myPat.Code,
          this.ecodes,
          this.ls.isAdmin || this.ls.userType == "secretary"
            ? this.myPat.UID
              ? this.myPat.UID
              : this.ls.doctor
            : null,
          hmoExamCode,
          hmoExamName,
          this.myPat.PRN2,
          this.myPat.Code2,
          this.myPat.HMOExamCode2,
          this.myPat.HMOExamName2,
          this.clalitReferral()
        )
        .subscribe(
          (data) => {
            this.closed.emit("awl");
          },
          (error) => {
            console.log(error);
          }
        );
  }

  deleteAWL() {
    this.patservice.deleteAWL(this.awl).subscribe(
      (data) => {
        this.closed.emit("awl");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  prepareAWL() {
    if (!this.myPat.PID) {
      //save the patient and then open
      this.hideSave = true;
      this.patservice.savePatient(this.myPat).subscribe(
        (data) => {
          if (data.hasOwnProperty("error")) {
            this.warning = data["error"];
            this.hideSave = false;
          } else {
            if (data["PID"]) {
              this.myPat.PID = data["PID"];
              this.openAWL = true;
            }
          }
        }, // success path
        (error) => {
          // error path(data)=>
          this.warning = error.error.error;
          this.hideSave = false;
        }
      );
    } else this.openAWL = true;
  }

  checklmp() {
    if (this.awlLMP) {
      let dt = new Date(this.awlLMP);
      if (dt < this.minLMP || dt > this.maxLMP) this.invalidlmp = "is-invalid";
      else this.invalidlmp = "";
    }
  }

  // only sent for Clalit patients - other HMOs leave these columns alone
  clalitReferral() {
    if (this.myPat.HMO != 'Clalit') return null;
    return {
      refDocName: this.myPat.refDocName,
      refDocLastName: this.myPat.refDocLastName,
      refDocID: this.myPat.refDocID,
      BranchProviderID: this.myPat.BranchProviderID,
      BranchProviderName: this.myPat.BranchProviderName,
    };
  }

  checkPRN() {
    if (this.myPat.Code && this.myPat.PRN && this.myPat.PRN.length > 8 && this.myPat.Code.length > 4) {
      this.patservice.checkPRN(this.myPat.ID, this.myPat.PRN, this.myPat.Code).subscribe(
        (data) => {
          if (data["response"] == "") {
            //verified
            this.PRNVerified = true;
            this.prnerr = null;
            this.iderr = null;
          } else {
            this.iderr = null;
            if (data["response"].indexOf("התחייבות לא שייך למבוטח") > -1) this.iderr = data["response"];
            this.prnerr = data["response"];
          }
        },
        (err) => {
          this.prnerr = err["error"];
        }
      );
    }
  }

  checkLength() {
    if (!this.ls.PRNcheck) return;
    this.PRNVerified = false;
    if (this.myPat.PRN && this.myPat.PRN.length > 0 && this.myPat.PRN.length < 9)
      this.prnerr = "PRN invalid";
    else this.prnerr = null;
    if (this.myPat.Code && this.myPat.Code.length > 0 && this.myPat.Code.length < 5)
      this.treatmenterr = "is-invalid";
    else this.treatmenterr = null;
  }

  IDValidator() {
    if (this.myPat.IsID == 0) return true;
    let id: any = this.myPat.ID.replace("-", "");
    if (id.length < 9 || isNaN(id)) {
      // Make sure ID is formatted properly
      return false;
    }
    let sum = 0,
      incNum;
    for (let i = 0; i < id.length; i++) {
      incNum = Number(id[i]) * ((i % 2) + 1); // Multiply number by 1 or 2
      sum += incNum > 9 ? incNum - 9 : incNum; // Sum the digits up and add to total
    }
    return sum % 10 === 0;
  }

  receive() {
    //mark as recived in db
    this.patservice.receivePat(this.awl).subscribe(
      (data) => {
        this.closed.next("awl");
      },
      (err) => {
        console.log(err);
      }
    );
  }

  getTodayListExamTypes() {
    if (this.ls.ClinicID === 150) {
      // שרן קרדיולוגיה
      return this.echoExamList;
    }
    if (this.ls.maccabiExams && (this.ls.hasPremission("Pneumology") || this.ls.hasPremission("Methacholine"))) {
      return this.ls.maccabiExams.map(exam => exam.exam_name);
    }
    if ((this.ls.hasPremission("Pneumology") || this.ls.hasPremission("Methacholine"))) {
      const examList = [];
      if (this.ls.hasPremission("Pneumology")) {
        examList.push("תפקודי ריאה");
      }
      if (this.ls.hasPremission("Methacholine")) {
        examList.push("בדיקת תגר מטכולין");
      }
      if (this.ls.hasPremission("Pneumology") && this.ls.hasPremission("Methacholine")) {
        examList.push("תפקודי ריאה+בדיקת תגר מטכולין");
      }
      return examList;
    }
    return this.allCardioExamsList;
  }

  getExamCodes(examName: string): string[] {
    if (!this.ls.maccabiExams) return [];
    const exam = this.ls.maccabiExams.find(e => e.exam_name === examName);
    return exam ? [exam.code] : [];
  }

  addCode() {
    if (!this.ecodes) {
      this.ecodes = [];
      this.ecodeTxt = [];
    }
    if (!this.ecodes.includes(this.ecode)) {
      this.ecodes.push(this.ecode);
      for (let ec of this.ls.ExamCodes) {
        if (this.ecode == ec[0]) this.ecodeTxt.push(ec[1] + "(" + ec[0] + ")");
      }
    }
    setTimeout(() => {
      this.ecode = 0;
    }, 1);
  }

  removeCode(index: number) {
    this.ecodes.splice(index, 1);
    this.ecodeTxt.splice(index, 1);
  }

  copyPat() {
    this.copyNote = null;
    if (!this.copyTo) return;
    this.tryCopy = true;
    this.patservice.copyPat(this.myPat.PID, this.copyTo).subscribe(
      (d) => {
        this.copyNote = "Patient copied";
        this.tryCopy = false;
      },
      (error) => {
        this.tryCopy = false;
        this.copyNote = error.error.error;
      }
    );
  }

  hasAllRequiredFields(): boolean {
    const requiredFields = [
      this.ls.hasPremission("requirePatientDetails")
        ? (this.myPat?.FirstEng, this.myPat?.LastEng, this.Birth)
        : true,
      this.ls.hasPremission("requireHMO") ? this.myPat?.HMO : true,
    ];

    return !requiredFields.some((field) => field === undefined || field === null || field === "");
  }

  getMissingFieldsTooltip(isTodayList: boolean = false): string {
    const missingFields: string[] = [];

    if (this.ls.hasPremission("requirePatientDetails")) {
      if (!this.myPat?.FirstEng?.trim()) {
        missingFields.push("First Name (English)");
      }
      if (!this.myPat?.LastEng?.trim()) {
        missingFields.push("Last Name (English)");
      }
      if (!this.Birth) {
        missingFields.push("Birth Date");
      }
    }
    if (this.ls.hasPremission("requireHMO") && !this.myPat?.HMO) {
      missingFields.push("HMO");
    }

    return missingFields.length > 0
      ? `Please fill in the required fields`
      : isTodayList
      ? `Add to TodayList`
      : `Save patients details`;
    // return missingFields.length > 0
    //   ? this.translate.instant("GUI.Tooltips.Please fill in the required fields")
    //   : isTodayList
    //   ? this.translate.instant("GUI.Tooltips.Add to TodayList")
    //   : this.translate.instant("GUI.Tooltips.Save patients details");
  }
}
